import React from "react";

export default class About extends React.Component {
  static propTypes = {};

  render() {
    return (
      // TODO : Make a paragraph to introduce myself
      <div />
    );
  }
}
